var themeNameLight = 'light';
var themeNameDefault = themeNameLight;

export { themeNameDefault, themeNameLight };
